// Programación semanal de líderes — AUTORIZA CAPTURA RUNTIME (P4).
// Mirror de la tabla `programacion_lideres` (migración 00005).
//
// El backend en POST /api/registros valida contra esta tabla:
//   "¿hay row para (lider_user_id = ctx.user_id, fecha, turno_id, linea_id)?"
//     → sí: deja capturar.
//     → no: 403 "no estás programado en esta línea hoy".
import { z } from 'zod';
const semanaIsoRegex = /^[0-9]{4}-W[0-9]{2}$/;
export const programacionLiderSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    semana_iso: z.string().regex(semanaIsoRegex, 'Formato YYYY-Www (ej. 2026-W21)'),
    fecha: z.string().date(),
    turno_id: z.string().uuid(),
    lider_user_id: z.string().uuid(),
    linea_id: z.string().uuid(),
    es_linea_principal: z.boolean(),
    programada_por_coordinador_user_id: z.string().uuid(),
    created_at: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=programacion_lider.js.map